var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7071 19.9786C19.3166 20.3691 18.6834 20.3691 18.2929 19.9786C17.9024 19.5881 17.9024 18.9549 18.2929 18.5644L22.5355 14.3217C22.9261 13.9312 23.5592 13.9312 23.9497 14.3217C24.3403 14.7123 24.3403 15.3454 23.9497 15.736L19.7071 19.9786Z",
    fill: "var(--color-blue)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2929 11.4349C17.9024 11.0444 17.9024 10.4112 18.2929 10.0207C18.6834 9.63019 19.3166 9.63019 19.7071 10.0207L23.9497 14.2634C24.3403 14.6539 24.3403 15.287 23.9497 15.6776C23.5592 16.0681 22.9261 16.0681 22.5355 15.6776L18.2929 11.4349Z",
    fill: "var(--color-blue)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8C5 6.34315 6.34315 5 8 5H16C16.5523 5 17 5.44772 17 6C17 6.55228 16.5523 7 16 7H8C7.44772 7 7 7.44772 7 8V22C7 22.5523 7.44772 23 8 23H16C16.5523 23 17 23.4477 17 24C17 24.5523 16.5523 25 16 25H8C6.34315 25 5 23.6569 5 22V8Z",
    fill: "var(--color-blue)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15C11 14.4477 11.4477 14 12 14H22C22.5523 14 23 14.4477 23 15C23 15.5523 22.5523 16 22 16H12C11.4477 16 11 15.5523 11 15Z",
    fill: "var(--color-blue)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.78004369.svg";
export { ForwardRef as ReactComponent };